import getUser from './user/getUser'

const isUserLogin=()=>{
  // 兼容老版本 读取 localStorage中token
  const userToken = getUser().token || ''
  return !!userToken && userToken.length > 0
}

export default isUserLogin